module.exports = __webpack_public_path__ + "static/media/team-joe.f1ed09e9.jpg";